import { v4 as uuid } from "uuid"
import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class CandidateAllocationPeriod {
  uid: string = uuid()
  key: string = ""
  type: string = ""
  start: string = ""
  end: string = ""
  status: string = ""
  allocation: number = 0
  pricingKey: string = ""

  constructor(
    data: {
      uid: string
      key: string
      type: string
      start: string
      end: string
      status: string
      allocation: number
      pricingKey: string
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.key = data.key
      this.type = data.type
      this.start = data.start
      this.end = data.end
      this.status = data.status
      this.allocation = data.allocation
      this.pricingKey = data.pricingKey
    }
  }
}
